/** Parsing of the free-text tag inputs used by the search and note forms. */

export function parseTagInput(raw: string): readonly string[] {
  return raw
    .split(/[,\s]+/)
    .map((tag) => tag.trim())
    .filter((tag) => tag !== "");
}
